import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { API_BASE_URL } from "../api/config";
import { rawFetch } from "../api/httpClient";

export const FavoritesList = () => {
  const [patientId, setPatientId] = React.useState("");
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchFavorites = async () => {
    if (!patientId.trim()) return;
    setLoading(true);
    try {
      const res = await rawFetch(`${API_BASE_URL}/patients/${patientId.trim()}/favorites`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      const list = Array.isArray(json) ? json : json?.data ?? [];
      setData(list);
    } catch (e) {
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <FavoriteIcon /> Favoris (Dream team)
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        GET /patients/{"{userId}"}/favorites — liste des professionnels favoris du patient.
      </Alert>
      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
        <TextField size="small" label="ID Patient" value={patientId} onChange={(e) => setPatientId(e.target.value)} />
        <Button variant="contained" onClick={fetchFavorites} disabled={!patientId.trim()}>
          Charger les favoris
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "primary.main", color: "white" }}>
              <TableCell>ID Pro</TableCell>
              <TableCell>Détail</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 && !loading ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                  Saisir un ID patient et charger
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, i) => (
                <TableRow key={row.id ?? row.professionalId ?? i} hover>
                  <TableCell>{row.professionalId ?? row.id ?? "—"}</TableCell>
                  <TableCell>{typeof row === "object" ? JSON.stringify(row) : row}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
